import React, { useState, useEffect, useMemo } from 'react';
import { TreeSelect } from 'antd';
import FormRow from '../../../common/formComponents/FormRow/FormRow';
import FormItem from '../../../common/formComponents/FormItem/FormItem';
import { generateAddress } from '../../../../utils/generateAddress';
import { getReplacedString } from '../../../../../../helpers/getReplacedString';
import useHousingStockState from '../../../../hooks/useHousingStockState';

const createFlat = (flat) => ({
  key: flat.addressId,
  value: flat.addressId,
  title: flat.address.name
    ? flat.address.typeName
      ? `${flat.address.typeName} ${flat.address.name}`
      : flat.address.name
    : flat.address.typeName
    ? flat.address.typeName
    : 'Не указано',
  address: generateAddress(flat, flat.address),
});

export const TreeSelectFlat = ({
  form,
  flats,
  fieldName = 'flatData',
  treeSelectExtraProps = {},
}) => {
  const [data, setData] = useState([]);
  const [value, setValue] = useState(null);

  // set tree data
  useEffect(() => {
    if (flats.length) {
      const houseIndices = new Map();
      const data = [];

      flats.forEach((flat) => {
        const index = houseIndices.get(flat.houseId);

        const newFlat = createFlat(flat);

        if (index === undefined) {
          houseIndices.set(flat.houseId, data.length);

          const address = generateAddress(flat);

          const house = {
            key: flat.houseId,
            value: flat.houseId,
            selectable: false,
            title: address,
            address,
            children: [newFlat],
          };

          data.push(house);
        } else {
          data[index].children.push(newFlat);
        }
      });

      setData(data);
    }
  }, [flats]);

  const filterTreeNode = (val, node) => {
    const value = getReplacedString(val);
    const address = getReplacedString(node.props.address);

    return address.includes(value);
  };

  const handleSelect = (value, node) => {
    const val = { ...value, label: node.props.address };
    setValue(val);
  };

  useEffect(() => {
    form.setFieldsValue({ flatData: value });
  }, [value, form.setFieldsValue]);

  return (
    <FormRow>
      <FormItem label="Выберите квартиру">
        {form.getFieldDecorator(fieldName, {
          rules: [{ required: true, message: 'Выберите квартиру' }],
        })(
          <TreeSelect
            treeData={data}
            showSearch
            labelInValue
            filterTreeNode={filterTreeNode}
            treeNodeFilterProp="address"
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            showCheckedStrategy={TreeSelect.SHOW_PARENT}
            onSelect={handleSelect}
            {...treeSelectExtraProps}
          />
        )}
      </FormItem>
    </FormRow>
  );
};

const TreeSelectFlatWithState = (props) => {
  const { housingStockState } = useHousingStockState();
  const flats = useMemo(
    () => housingStockState?.data || [],
    [housingStockState]
  );

  return (
    <TreeSelectFlat
      {...props}
      flats={flats}
    />
  );
};

export default TreeSelectFlatWithState;
